import { safeId } from "@otto-ec/otto-components-utils/utils/safeId";
import { componentsScope } from "../../../../common/utils/logger.js";
import type { Props } from "../SheetV1.types.js";
import type { DefineComponentProps } from "../../../../common/runtime/types.js";

export const sheetScope = /*           */ componentsScope.scope("sheet-v1");

/**
 *
 */
export const autoIdPrefix = "auto-";

export const flags = ["unsafeHtml", "unsafeUrl", "trigger"] as const;
export type PropFlag = (typeof flags)[number];

export const props: DefineComponentProps<
  Props,
  {
    /**
 *
 *
 */
    flags?: PropFlag[];
  }
> = {
  open: { type: "Boolean", flags: ["trigger"] },
  headline: { flags: ["unsafeHtml"] },
  headlineLevel: { type: "Number", attribute: "headline-level" },
  id: { reflect: true, flags: ["unsafeHtml"] },
  url: {},
  base64Url: { attribute: "base64-url" },
  hideHeader: { type: "Boolean", attribute: "hide-header" },
  hideCloseButton: { type: "Boolean", attribute: "hide-close-button" },
  hideBackButton: { type: "Boolean", attribute: "hide-back-button" },
  fullHeight: { type: "Boolean", attribute: "full-height" },
  adaptiveAlignment: { attribute: "adaptive-alignment" },
  maxWidthCentered: { attribute: "max-width-centered" },
  ocAriaLabel: { attribute: "oc-aria-label" },
  noContentPadding: { type: "Boolean", attribute: "no-content-padding" },
  discardContentOnInactive: { type: "Boolean", attribute: "discard-content-on-inactive" },
  allowedErrorStatusCodes: { type: "Array", attribute: "allowed-error-status-codes" },
  disableCloseInteractions: { type: "Boolean", attribute: "disable-close-interactions" },
  disableTracking: { type: "Boolean", attribute: "disable-tracking" },
  extraData: { type: "Object", attribute: "extra-data" },
  closeHistoryMode: { attribute: "close-history-mode" },
};

/**
 *
 *
 *
 *
 *
 *
 *
 */
export const mergeProps = (
  target: Partial<Props> = {},
  excludeFlags: PropFlag[] = [],
  ...source: (Partial<Props> | null)[]
): Partial<Props> => {
  for (const src of source) {
    for (const [key, { flags: propFlags = [] }] of Object.entries(props)) {
      const propKey = key as keyof Props;
      const propVal = src?.[propKey];

      /*                                                                */
      /*                                                                                           */
      if (propVal) {
        /*                                                                     */
        if (!propFlags.some((flag) => excludeFlags.includes(flag))) {
          target[propKey] = propVal as never;
        }
      }
    }
  }

  return target;
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function applyPropsToSheetElement(
  sheet: HTMLOcSheetV1Element,
  newProps: Partial<Props>,
): string {
  /*                                         */
  mergeProps(sheet, [], newProps);

  /*                             */
  sheet.id ??= safeId(undefined, autoIdPrefix);

  /*                                            */
  sheet.setAttribute("id", sheet.id);

  return sheet.id;
}
